<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="stage3"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'district',
		'Total_App_Recieved',
		'recieved_Coverage_Area',
		'total_Approved_Application',
		'approved_Coverage_Area',
		'total_App_Incomplete',
		'total_App_Pending',
		'total_App_Rejected',
        'pending_At_DMICADA',
        'pending_At_Admin',

        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'STAGE3_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="district">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="district" display="menu"></p-columnFilter>
                    <p-sortIcon field="district"></p-sortIcon>
                </th>
                <th pSortableColumn="Total_App_Recieved">{{'TOTAL_APP_RECIEVED'| translate}}
                    <p-columnFilter type="text" field="Total_App_Recieved" display="menu"></p-columnFilter>
                    <p-sortIcon field="Total_App_Recieved"></p-sortIcon>
                </th>
                <th pSortableColumn="recieved_Coverage_Area">{{'RECIEVED_COVERAGE_AREA'| translate}}
                    <p-columnFilter type="text" field="recieved_Coverage_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="recieved_Coverage_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="total_Approved_Application">{{'TOTAL_APPROVED_APPLICATION'| translate}}
                    <p-columnFilter type="text" field="total_Approved_Application" display="menu"></p-columnFilter>
                    <p-sortIcon field="total_Approved_Application"></p-sortIcon>
                </th>
                <th pSortableColumn="approved_Coverage_Area">{{'APPROVED_COVERAGE_AREA'| translate}}
                    <p-columnFilter type="text" field="approved_Coverage_Area" display="menu"></p-columnFilter>
                    <p-sortIcon field="approved_Coverage_Area"></p-sortIcon>
                </th>
                <th pSortableColumn="total_App_Incomplete">{{'TOTAL_APP_INCOMPLETE'| translate}}
                    <p-columnFilter type="text" field="total_App_Incomplete" display="menu"></p-columnFilter>
                    <p-sortIcon field="total_App_Incomplete"></p-sortIcon>
                </th>
                <th pSortableColumn="total_App_Pending">{{'TOTAL_APP_PENDING'| translate}}
                    <p-columnFilter type="text" field="total_App_Pending" display="menu"></p-columnFilter>
                    <p-sortIcon field="total_App_Pending"></p-sortIcon>
                </th>
                <th pSortableColumn="total_App_Rejected">{{'TOTAL_APP_REJECTED'| translate}}
                    <p-columnFilter type="text" field="total_App_Rejected" display="menu"></p-columnFilter>
                    <p-sortIcon field="total_App_Rejected"></p-sortIcon>
                </th>
                <th pSortableColumn="pending_At_DMICADA">{{'PENDING_AT_DMICADA'| translate}}
                    <p-columnFilter type="text" field="pending_At_DMICADA" display="menu"></p-columnFilter>
                    <p-sortIcon field="pending_At_DMICADA"></p-sortIcon>
                </th>
                <th pSortableColumn="pending_At_Admin">{{'ENDING_AT_ADMIN'| translate}}
                    <p-columnFilter type="text" field="pending_At_Admin" display="menu"></p-columnFilter>
                    <p-sortIcon field="pending_At_Admin"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-stage3>
            <tr>
                <td>{{stage3.district}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(stage3.district,'All')">{{stage3.Total_App_Recieved}}</a></td>
                <td>{{stage3.recieved_Coverage_Area}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(stage3.district,'Approved')">{{stage3.total_Approved_Application}}</a></td>
                <td>{{stage3.approved_Coverage_Area}}</td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(stage3.district,'Incomplete')">{{stage3.total_App_Incomplete}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(stage3.district,'Pending')">{{stage3.total_App_Pending}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog(stage3.district,'Rejected')">{{stage3.total_App_Rejected}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(stage3.district,'PendingDMICADAStage3')">{{stage3.pending_At_DMICADA}}</a></td>
                <td><a class="link_pointer" (click)="showMaximizableDialog_pending(stage3.district,'PendingAdminStage3')">{{stage3.pending_At_Admin}}</a></td>
                
            </tr>
        </ng-template>
        <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td >{{totalApp | number:'1.0-2'}}</td>
                <td >{{totalReceivedCoverageArea | number:'1.0-2'}}</td>
                <td >{{totalApproveApp | number:'1.0-2'}}</td>
                <td >{{totalApprovedCoverageArea | number:'1.0-2'}}</td>
                <td >{{totalAppIncomplete | number:'1.0-2'}}</td>
                <td >{{totalAppPending | number:'1.0-2'}}</td>
                <td >{{totalAppRejected | number:'1.0-2'}}</td>
                <td >{{pendingAtDmicada | number:'1.0-2'}}</td>
                <td >{{pendingAtAdmin | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td >  Grand Total</td>
                <td >{{grandTotalApp | number:'1.0-2'}}</td>
                <td >{{grandTotalReceivedCoverageArea | number:'1.0-2'}}</td>
                <td >{{grandTotalApproveApp | number:'1.0-2'}}</td>
                <td >{{grandTotalApprovedCoverageArea | number:'1.0-2'}}</td>
                <td >{{grandTotalAppIncomplete | number:'1.0-2'}}</td>
                <td >{{grandTotalAppPending | number:'1.0-2'}}</td>
                <td >{{grandTotalAppRejected | number:'1.0-2'}}</td>
                <td >{{grandPendingAtDmicada | number:'1.0-2'}}</td>
                <td >{{grandPendingAtAdmin | number:'1.0-2'}}</td>
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>
    <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Stage 3 Report Of All Applications of {{value}} "  [(visible)]="displayMaximizable_all" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_all" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog> 
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Stage 3 Report Of Verified Applications of {{value}} "  [(visible)]="displayMaximizable_verified" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_verified" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Stage 3 Report Of Incomplete Applications of {{value}} "  [(visible)]="displayMaximizable_incomplete" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_incomplete" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Stage 3 Report Of Pending Applications of {{value}} "  [(visible)]="displayMaximizable_pending" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_pending" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog>
   <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Tank Stage 3 Report Of Rejected Applications of {{value}} "  [(visible)]="displayMaximizable_rejected" [modal]="true" [style]="{width: '100%'}"  
    [draggable]="false" [resizable]="false" >
    
    <app-drill-down-abstract-report  *ngIf="displayMaximizable_rejected" [drilldownDetails]="drilldownDetails"></app-drill-down-abstract-report>
    
   </p-dialog>
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Report Of Pending at DMICADA Stage 3 Applications of {{value}} "  [(visible)]="displayMaximizable_dmicada" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-tank-stage-report  *ngIf="displayMaximizable_dmicada" [drilldownDetails]="drilldownDetails"></app-drill-down-tank-stage-report>
   
  </p-dialog>
  <p-dialog  class="drilldown_details" [baseZIndex]="-100" header="Drill Down Report Of Pending at ADMIN Stage 3 Applications of {{value}} "  [(visible)]="displayMaximizable_admin" [modal]="true" [style]="{width: '100%'}"  
   [draggable]="false" [resizable]="false" >
   
   <app-drill-down-tank-stage-report  *ngIf="displayMaximizable_admin" [drilldownDetails]="drilldownDetails"></app-drill-down-tank-stage-report>
   
  </p-dialog>